module.exports = __webpack_public_path__ + "static/media/KMH_4899.8223815b.jpg";